module.exports = __webpack_public_path__ + "img/Postmodernisme_Pushwagner_.0da150b7.jpg";